import { createReducerFromMap } from "@coverme/redux";
import { cloneDeep } from "lodash-es";

const initialState = {
    charityAssistanceTypes: [],
    medicalRecordNumber: "",
    patientRecordNumber: "",
    nameOfReferringPhysician: "",
    typeOfService: "",
    scheduledDateOfService: "",
    governmentAssistanceTypes: [],
};

function updateSupplemental(state, data) {
    const currentSupplemental = cloneDeep(data.value);
    return currentSupplemental;
}

function resetInterview(state, action) {
    return initialState;
}

function getInterview(state, action) {
    const { value } = action;
    if (value.supplementalInfo) {
        if (value.supplementalInfo) {
            return updateSupplemental(state, { value: value.supplementalInfo });
        }
    }

    return state;
}

export const supplementalReducer = createReducerFromMap(initialState, {
    UPDATE_SUPPLEMENTAL_COMPLETE: updateSupplemental,
    RESET_INTERVIEW: resetInterview,
    GET_INTERVIEW_COMPLETE: getInterview,
});
